const toPascal = (pVal: string) => {
  return `${pVal.charAt(0).toUpperCase()}${pVal.slice(1).toLowerCase()}`;
};

export { toPascal };

export const ReplaceMinus = (value: any, placeholder: string = "None") => {
  if (!value || value === "null") return placeholder;
  if (Number(value) === -1) return placeholder;
  return value;
};
export const formatLabel = (key: string) =>
  key.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
